<template>
  <div class="getInvite">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 80px">
            <el-select
              v-model="filter.time_type"
              clearable
              filterable
              placeholder="类型"
              @change="changeTime(), search()"
            >
              <el-option label="本周" value="week"></el-option>
              <el-option label="上周" value="prevWeek"></el-option>
              <el-option label="本月" value="month"></el-option>
              <el-option label="上月" value="prevMonth"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 260px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelPerfReport.51h4zb87asw0')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87b7w0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87bk00')
              "
              :picker-options="pickerOptions"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <!-- <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51yzwntly2o0")
          }}</span> -->
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width: 280px">
            <el-input
              v-model="filter.keyword"
              clearable
              placeholder="可检索校区名称、区域名称"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelPerfReport.51h4zb87em80")
            }}</el-button
          >
        </div> -->
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
export default {
  name: "analysisreport-getInvite",
  data() {
    return {
      reportParams: {
        wayString: "getInvite", //传递到子组件的方法名称
        Title: "招生邀约状况统计表",
      },

      //筛选
      filter: {
        time_type: "month",
        rang_time: "",
        starttime: "",
        endtime: "",
        coursetype_id: "", //班组
        keyword: "",
      },
      // 筛选的下拉列表
      filterList: {
        coursetypeList: [], //班组-下拉数据
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.changeTime();
    this.courseTypeRecruitApi();
  },
  mounted() {},
  methods: {
    changeTime() {
      if (this.filter.time_type == "week") {
        this.filter.rang_time = [
          this.$Common.getWeekStartAndEnd(0)[0],
          this.$Common.getWeekStartAndEnd(0)[1],
        ];
      } else if (this.filter.time_type == "prevWeek") {
        this.filter.rang_time = [
          this.$Common.getWeekStartAndEnd(-1)[0],
          this.$Common.getWeekStartAndEnd(-1)[1],
        ];
      } else if (this.filter.time_type == "month" || !this.filter.time_type) {
        this.filter.rang_time = [
          this.$Common.getMonthStartAndEnd(0)[0],
          this.$Common.getMonthStartAndEnd(0)[1],
        ];
      } else if (this.filter.time_type == "prevMonth") {
        this.filter.rang_time = [
          this.$Common.getMonthStartAndEnd(-1)[0],
          this.$Common.getMonthStartAndEnd(-1)[1],
        ];
      }
      this.filter.starttime = this.filter.rang_time[0];
      this.filter.endtime = this.filter.rang_time[1];
    },
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    //检索
    search() {
      this.filter.starttime = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.endtime = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.getInvite {
  // height: 100vh;
  font-size: 20px;
}
</style>
